export default __webpack_public_path__ + "static/media/7.96294a4d.jpg";